// backend/src/lib/theme.js
const KEY = "admin_theme"; // festivalLight | festivalDark | festivalHC

/**
 * Helper global (también exportado)
 * - Lo usa el topbar: window.__setTheme("festivalDark")
 */
export function __setTheme(t) {
  document.documentElement.setAttribute("data-theme", t);
  localStorage.setItem(KEY, t);
}

function bindThemeButtons() {
  if (window.__themeButtonsBound) return;
  window.__themeButtonsBound = true;

  document.addEventListener("click", (evt) => {
    const btn = evt.target?.closest?.("[data-set-theme]");
    if (!btn) return;

    const theme = btn.getAttribute("data-set-theme");
    if (!theme) return;

    evt.preventDefault();
    __setTheme(theme);
  });
}

export function initTheme() {
  const saved = localStorage.getItem(KEY);
  const theme = saved || "festivalDark";

  // aplica tema inicial
  __setTheme(theme);

  // para evitar flash, dejamos listo un helper global
  window.__setTheme = __setTheme;

  // Tambien soporta botones con data-set-theme (sin depender de onclick inline)
  bindThemeButtons();
}
